<template>
    <SettingsLayout>
        <!-- <Head title="Stammdaten - Grundeinstellungen" /> -->
        <Head :title="`${page_name} - Grundeinstellungen`" />

        <template #breadcrumb>{{ page_name }}</template>
        <template #controls>
            <HeaderLink
                class="mr-3"
                href="/einstellungen/behandlungsraeume"
                type="close"
                >Zurück</HeaderLink
            >
            <HeaderButton @click="submitForm()">Speichern</HeaderButton>
        </template>
        <Heading title="Terminservice" />

        <p class="max-w-2xl text-sm text-oteoText">
            Im Terminservice richten Sie einmalig die Texte für
            Terminbestätigung und Reminder ein, welche Sie an Ihre Patient/innen
            versenden. Direkt nach Terminvergabe wird eine Bestätigung per
            E-Mail oder SMS verschickt. Die Anzahl und den zeitlichen Abstand
            der Reminder können Sie zusätzlich aktivieren.
        </p>

        <div class="flex max-w-4xl mt-16 text-sm text-oteoText">
            <div class="basis-1/2 border-r flex flex-col border-gray-200 pr-16">
                <div class="">
                    <Label>Titel</Label>

                    <Input v-model="form.title" class="w-full" type="text" />
                    <div class="mt-2 text-red-600 text-sm" v-if="errors.title">
                        {{ errors.title }}
                    </div>
                </div>
                <div class="mt-8">
                    <Label>Betreff</Label>

                    <Input v-model="form.subject" class="w-full" type="text" />
                    <div
                        class="mt-2 text-red-600 text-sm"
                        v-if="errors.subject"
                    >
                        {{ errors.subject }}
                    </div>
                </div>
                <div class="mt-8">
                    <Label>Text</Label>
                    <Textarea
                        class="w-full h-36 resize-none"
                        v-model="form.confirmationContent"
                    />
                    <div
                        class="mt-2 text-red-600 text-sm"
                        v-if="errors.confirmationContent"
                    >
                        {{ errors.confirmationContent }}
                    </div>
                </div>
            </div>
            <div class="basis-1/2 pl-16 flex flex-col">
                <div class="">
                    <Label>Reminder</Label>
                    <div v-if="reminders.length <= 0"></div>
                    <div v-if="reminders.length > 0">
                        <div
                            class="flex items-center justify-between mb-4"
                            v-for="(reminder, index) in reminders"
                            :key="reminder.key"
                        >
                            <Input
                                v-model="reminder.value"
                                class="w-16"
                                type="number"
                                min="1"
                                step="1"
                                :class="{
                                    'bg-red-100':
                                        errors['reminders.' + index + '.value'],
                                }"
                            />

                            <Select
                                v-model="reminder.type"
                                class="w-32"
                                :class="{
                                    'bg-red-100':
                                        errors['reminders.' + index + '.type'],
                                }"
                            >
                                <option value="hours">Stunde(n)</option>
                                <option value="days">Tag(e)</option>
                            </Select>

                            vor Behandlung
                            <i
                                class="las la-times border-oteo-300 border rounded-md p-1 text-oteo-300 cursor-pointer"
                                @click="deleteReminder(index)"
                            ></i>
                        </div>
                    </div>

                    <div
                        @click="addReminder()"
                        class="cursor-pointer mt-4 text-oteo-300"
                        v-if="reminders.length < 3"
                    >
                        <i class="las la-plus"></i> Neuer Reminder anlegen
                    </div>
                </div>
                <div class="mt-auto">
                    <Label>Text Reminder</Label>
                    <Textarea
                        class="w-full h-36 resize-none"
                        v-model="form.reminderContent"
                    />
                    <div
                        class="mt-2 text-red-600 text-sm"
                        v-if="errors.reminderContent"
                    >
                        {{ errors.reminderContent }}
                    </div>
                </div>
            </div>
        </div>
    </SettingsLayout>
</template>

<script setup>
const page_name = "Terminservice";

const props = defineProps({
    errors: Object,
    title: String,
    subject: String,
    confirmationContent: String,
    reminderContent: String,
    reminders: Array,
});
const reminderCounter = ref(0);

let emtpyReminder = {
    key: reminderCounter.value,
    type: "days",
    value: 1,
};

function addReminder() {
    reminderCounter.value++;
    emtpyReminder.order = reminderCounter.value;
    reminders.value.push({ ...emtpyReminder });
}

function deleteReminder(index) {
    reminders.value.splice(index, 1);
}

// const reminders = ref([
//   {
//     key: reminderCounter.value,
//     type: "days",
//     value: 1,
//   },
// ]);
const reminders = ref(props.reminders ?? [emtpyReminder]);
let saveBtnClicked = false;

//onUnmounted(
//    Inertia.on("before", (e) => {
//        if (form.isDirty && !saveBtnClicked) {
//            return confirm(
//                "Sie haben ungespeicherte Eingaben. Wollen Sie diese Seite wirklich verlassen?"
//            );
//        }
//    })
//);

function submitForm() {
    saveBtnClicked = true;
    form.put("/appointmentService");
}

const form = useForm({
    title: props.title,
    subject: props.subject,
    confirmationContent: props.confirmationContent,
    reminderContent: props.reminderContent,
    reminders,
});

import SettingsLayout from "@/Layouts/Settings.vue";
import Input from "@/Components/Settings/Input.vue";
import Textarea from "@/Components/Textarea.vue";
import Select from "@/Components/Select.vue";
import Label from "@/Components/Settings/Label.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderLink.vue";
import Heading from "@/Components/Settings/Heading.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import { ref, onUnmounted } from "vue";
</script>
